module.exports = __webpack_public_path__ + "915283e3116503d0ce1cfd3939bfd8c3.ttf";